import * as React from 'react';

import { DataGridColumn } from '@rematter/ui-web';
import { cn } from '@rematter/ui-web/lib';

import { useTranslations } from '../../../i18n/useTranslations';
import { ProcessingTypeRecord } from '../../../types/processingType';

type UseProcessingTypesColumnsArgs = {
  onRowClick?: (cell: { row: ProcessingTypeRecord }) => void;
};

export const useProcessingTypesColumns = ({
  onRowClick,
}: UseProcessingTypesColumnsArgs = {}): DataGridColumn<ProcessingTypeRecord>[] => {
  const t = useTranslations();

  return React.useMemo(() => {
    const columns: DataGridColumn<ProcessingTypeRecord>[] = [
      {
        key: 'name',
        header: t.processingTypesView.table.columns.name,
        onClick: onRowClick,
        cell: ({ row }) => <span className="font-medium">{row.name}</span>,
        width: 200,
        sortable: true,
      },
      {
        key: 'code',
        header: t.processingTypesView.table.columns.code,
        onClick: onRowClick,
        cell: ({ row }) => (
          <span className="font-mono text-sm">{row.code}</span>
        ),
        width: 120,
        sortable: true,
      },
      {
        key: 'description',
        header: t.processingTypesView.table.columns.description,
        onClick: onRowClick,
        cell: ({ row }) => (
          <span className="text-neutral/60">{row.description || '—'}</span>
        ),
        width: 300,
      },
      {
        key: 'isActive',
        header: t.processingTypesView.table.columns.isActive,
        onClick: onRowClick,
        cell: ({ row }) => (
          <span
            className={cn(
              'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium',
              row.isActive
                ? 'bg-success/10 text-success'
                : 'bg-neutral/10 text-neutral/60',
            )}
          >
            {row.isActive ? 'Active' : 'Inactive'}
          </span>
        ),
        width: 100,
      },
      {
        key: 'createdAt',
        header: t.processingTypesView.table.columns.createdAt,
        onClick: onRowClick,
        cell: ({ row }) => (
          <span className="text-sm text-neutral/60">
            {new Date(row.createdAt).toLocaleDateString()}
          </span>
        ),
        width: 120,
        sortable: true,
      },
    ];

    return columns;
  }, [t, onRowClick]);
};
